import { useEffect, useRef, useState } from 'react';

export function useCountdown(endTime, onExpire) {
  const [progress, setProgress] = useState(100);
  const [remainingSeconds, setRemainingSeconds] = useState(0);
  const onExpireRef = useRef(onExpire);
  const expiredRef = useRef(false);

  onExpireRef.current = onExpire;

  useEffect(() => {
    if (!endTime) {
      setProgress(100);
      setRemainingSeconds(0);
      return undefined;
    }

    expiredRef.current = false;
    const end = new Date(endTime).getTime();
    if (Number.isNaN(end)) {
      setProgress(100);
      setRemainingSeconds(0);
      return undefined;
    }

    const start = Date.now();
    const totalMs = Math.max(end - start, 1);

    const tick = () => {
      const now = Date.now();
      const remaining = Math.max(end - now, 0);

      setProgress(Math.min(100, Math.max(0, (remaining / totalMs) * 100)));
      setRemainingSeconds(Math.ceil(remaining / 1000));

      if (remaining <= 0 && !expiredRef.current) {
        expiredRef.current = true;
        onExpireRef.current?.();
      }
    };

    tick();
    const timer = setInterval(tick, 200);
    return () => clearInterval(timer);
  }, [endTime]);

  return { progress, remainingSeconds };
}
